// Returns the client using the product.
function getProductClient() {
  return (getProductClientFromGlobal() || {}).clientName || 'other';
}

function getProductClientFromGlobal() {
  return Object
    .entries({
      'spsc': globals.spscFieldset,
      'nswh': globals.nswhFieldset,
    })
    .map(mapGlobal)
    .find(isGlobalSet);
}

function mapGlobal(entry) {
  const [clientName, globalState] = entry;
  return {
    clientName,
    globalState
  };
}

function isGlobalSet(clientMapping) {
  return clientMapping.globalState;
}

module.exports = getProductClient;
